/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Capability_UnchangedInputs */



/**
* | output |
* | --- |
* | "Already in that state — nothing changed." |
*
* @param {Partner_Admin_Capability_UnchangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_capability_unchanged = /** @type {((inputs?: Partner_Admin_Capability_UnchangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Capability_UnchangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bereits in diesem Zustand — nichts geändert.")
	return /** @type {LocalizedString} */ ("Already in that state — nothing changed.")
});